<template>
  <div class="cro_footer" :class="isFocus?'cor_footer_focus':''" :style="{zIndex:isShow?'99':(isFocus?'1001':'89')}">
    <!-- 分享按钮dialog -->
    <div class="btn_dialog" :class="{dialogshow: isShow}">
      <div class="share_btn">
        <img src="@assets/img/icon/wx.png" />
        <span>好友</span>
        <button open-type="share"></button>
      </div>
      <div class="share_btn" @click="getGoodEwm">
        <img src="@assets/img/icon/QRcode.png" />
        <span>海报</span>
      </div>
    </div>
    <!-- 海报图片dialog -->
    <div class="QRcode_dialog" v-if="QRshow">
      <img :src="canvasImg" />
    </div>
    <div class="share_mask2" v-if="isFocus" @click="inputClose"></div>
    <div class="share_mask" :class="{dialog_mask_show: isShow}" @click="close" v-if="isShow"></div>
    <!-- <div class="share_mask rq_share" :class="{dialog_QRcode_show: QRshow}" @click="QRCodeClose"></div> -->
    <div class="crowdFooterView" v-if="userInfo.userRole"  :class="{footer_focus: isFocus}">
      <div v-if="!isFocus" class="comment van-ellipsis" @click="focalTrue">{{text.length?text:'说点什么呗...'}}</div>
      <van-field
        v-else
        class="input_focus"
        v-model="text"
        center
        clearable
        @keyup.enter.native="inputImport"
        @blur="focalFalse"
        placeholder="说点什么..."
        placeholder-class="input_place"
        maxlength="25"
        type="text"
        ref="barInput"
        size="small"
      >
        <template #button>
          <van-button size="small" @click="send" type="primary" >发送</van-button>
        </template>
      </van-field>
    </div>
    <div class="notreg" v-if="!userInfo.userRole" @click="goToReg">注册后即可留言<van-icon name="arrow" /></div>
    <van-toast id="van-toast" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "crowd-footer",
  data() {
    return {
      isFocus: false, //input输入框是否获焦
      isShow: false, //分享模态框
      isCreate: false, //是否生成中，生成中点击无效
      QRshow: false, //二维码模态框
      shareImgPath: "", //海报生成图片路径
      canvasImg: "123", //canvas图片路径
      text: "", //文本
      poster: {
        //海报相关
        userImg:
          "https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1712216034,2924212808&fm=111&gp=0.jpg", //用户头像图片
        title: "", //直播标题名 例：第二十八届...
        typeName: "", //类型 例：品牌展览交流
        code:
          "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1587102024694&di=ee840c8ce7cdc223ce6f8115d361baa7&imgtype=0&src=http%3A%2F%2Fsrc.onlinedown.net%2Fimages%2Fxcs%2F10%2F2017-09-18_59bf6a2170092.jpg", //二维码
        fontFamily: "sans-serif", // 默认字体
        fontWeight: "normal"
      }
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      IsHasGetUser: "getIsHasGetUser", 
      exhibitionInfo: "getExhibitionInfo",
      roomInfo: "getRoomInfo",
      userInfo:"getUserInfo"
    }),
    viewer() {
      return this.$store.getters["getViewer"];
    } 
  },
  methods: {
    ...mapActions({
      LinkRegistry:"linkTo/LinkRegistry"
    }),
    //点击发言
    focalTrue(e) {
      // if (!this.IsHasGetUser) {
      //   this.getIsShow = true;
      //   return;
      // }
      if (this.viewer.Disabled) {
        this.$toast.fail("您已被禁言！");
        return;
      }
      this.isFocus = true;
      this.$nextTick(() => {
        this.$refs.barInput.focus();
      });
    },
    //输入框失去焦点
    focalFalse(e) {
      setTimeout(function(){
          window.scrollTo(0, 0)
      },100)
    },
    inputImport(str) {
      this.send();
    },
    //发送事件点击
    send() {
      if (/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.text)) {
        this.$toast.fail("请勿发送手机号！");
        // this.text = "";
        return;
      }
      if (this.text == "") return;
      this.$nextTick(() => {
        this.$refs.barInput.blur();
      });
      this.isFocus = false;
      this.$emit("watchliveSend", this.text);
      this.text = "";
    },
    inputClose() {
      this.isFocus = false;
    },
    //底部模态框出现
    open() {
      this.$store.commit("setIsFooterBtnShow", true);
      this.isShow = true;
    },
    //底部模态框消失
    close() {
      this.$store.commit("setIsFooterBtnShow", false);
      this.isShow = false;
    },
    //分享海报模态框消失
    QRCodeClose() {
      if (this.isCreate) return;
      this.QRshow = false;
      this.canvasImg = "";
    },
    //海报相关
    getGoodEwm() {
      this.QRshow = true;
    },
    //注册按钮点击
    goToReg(){
      this.LinkRegistry(0);
    }
  }
};
</script>

<style scoped lang="scss">
.cro_footer {
  position: absolute; 
  height: 0.64rem;
  // width: 100%;
  left: .2rem;
  bottom: 1.18rem;
  z-index: 101;
  .notreg{
    display: inline-block;
    width: 2.4rem;
    height: 0.64rem;
    padding-left: 0.1rem;
    line-height: 0.64rem;
    text-align: center;
    border-radius: 0.32rem;
    background: #fff;
    color: #f85b0f;
    i{
      font-size: 0.26rem;
      vertical-align: text-top;
    }
  }
  &.cor_footer_focus{
    bottom: 0;
    height: 0.5rem;
    left: 0;
    position: fixed;
  }
}
.crowdFooterView {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
}
.comment {
  height: 0.64rem;
  line-height: 0.64rem;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 0.32rem;
  padding-left: 0.28rem;
  width: 3.7rem;
  color: #fff;
  font-size: 0.24rem;
}
.footer_btn {
  display: flex;
}
.footer_btn .dianji {
  width: 0.64rem;
  height: 0.64rem;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  display: block;
  position: relative;
  border: none;
}
.footer_btn .dianji .btn_i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.footer_btn .share {
  margin-right: 0.2rem;
}
.footer_btn .share .btn_i {
  width: 0.32rem;
  height: 0.32rem;
}
.footer_btn .close .btn_i {
  width: 0.26rem;
  height: 0.26rem;
}
.share_mask2 {
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0.98rem;
  background: rgba(0, 0, 0, 0);
  transition: all 0.3s;
  opacity: 1;
}
.share_mask {
  position: fixed;
  z-index: 0;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0.98rem;
  background: rgba(0, 0, 0, 0.6);
  transition: all 0.3s;
  opacity: 0;
}
.share_mask.rq_share {
  transition: none;
}
.dialog_mask_show {
  opacity: 1;
  z-index: 99;
}
.dialog_QRcode_show {
  background: rgba(0, 0, 0, 0);
  transition: all 0.3s;
  z-index: 100;
}
.btn_dialog {
  height: 1.4rem;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: -100%;
  z-index: 110;
  background-color: #fff;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  overflow: hidden;
  transition: all 0.3s;
}
.dialogshow {
  bottom: 0;
}
.btn_dialog .weui-icon-btn_more {
  display: none;
}
.btn_dialog .share_btn {
  width: 50%;
  text-align: center;
  position: relative;
  padding: 0.22rem 0;
}
.btn_dialog .share_btn img {
  width: 0.64rem;
  height: 0.64rem;
  display: block;
  margin: 0 auto;
}
.btn_dialog .share_btn span {
  display: block;
  font-size: 0.24rem;
  line-height: 0.48rem;
}
.btn_dialog .share_btn button {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
}
.footer_focus {
  background: #fff;
  width: 100vw;
  left: 0;
}
.input_focus {
  height: 0.98rem;
  line-height: 0.5rem;
  width: 100%;
  padding:0.2rem 0.28rem;
  border-radius: 0;
  border: none;
  background: #fff;
  color: #000;
}
.input_place {
  color: #bfbfbf;
  font-size: 0.3rem;
}
.QRcode_dialog {
  width: 5.6rem;
  height: 6.48rem;
  background: #fff;
  position: fixed;
  overflow: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 3px;
  z-index: 5000;
}
.QRcode_dialog image {
  width: 100%;
  height: 100%;
}

.rq_img image {
  width: 2.1rem;
  height: 2.1rem;
}

.huahuahua {
  position: fixed;
  top: 1rem;
  left: 1rem;
  background: #000;
  color: #fff;
  z-index: 1000;
}
</style>
